export enum ColorEnum {
  WHITE_EF = '#f2f1ef',
  LIGHT_GRAY_F6 = '#f9f7f6',
  GRAY_EE = '#eee',
  GRAY_CC = '#ccc',
  PATTERNS_BLUE_F8 = '#e8f6f8',
  DARK_BLUE_43 = '#223043',
  DARK_BLUE_3F = '#1D2C3F',
  DARK_BLUE_32 = '#1F2532',
  BLUE_FF = '#007bff',
  BLUE_B3 = '#0056b3',
  BONDI_BLUE_AE = '#00A2AE',
  GREEN_00 = '#74FF00',
  GREEN_74FF00 = '#74FF00',
  GREEN_99FF00 = '#99FF00',
  GREEN_6CC711 = '#6CC711',
  GREEN_11 = '#b7ce11',
  GREEN_21 = '#429321',
  ORANGE_16 = '#F59D16',
  ORANGE_19 = '#F46519',
  PINK_5B = '#E5005B',
}
